import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickAccessPanel = () => {
  const emergencyContacts = [
    {
      title: 'Critical Compliance Issues',
      contact: 'Bonalizah Tio',
      email: 'admin@hrpacificrbs.com',
      phone: '+675 78808282',
      icon: 'AlertCircle'
    },
    {
      title: 'Technical Support',
      contact: 'Pacific RBS Support',
      email: 'admin@hrpacificrbs.com',
      phone: '+675 78808282',
      icon: 'Headphones'
    }
  ];

  const governmentResources = [
    {
      title: 'PNG Department of Labour & Industrial Relations',
      url: 'https://www.labour.gov.pg',
      icon: 'ExternalLink'
    },
    {
      title: 'NASFUND Official Website',
      url: 'https://www.nasfund.com.pg',
      icon: 'ExternalLink'
    },
    {
      title: 'PNG Internal Revenue Commission',
      url: 'https://www.irc.gov.pg',
      icon: 'ExternalLink'
    },
    {
      title: 'PNG Employment Act 1978 (Full Text)',
      url: '#',
      icon: 'FileText'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Emergency Contacts */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Phone" size={20} color="var(--color-error)" />
          Emergency Contacts
        </h3>
        <div className="space-y-4">
          {emergencyContacts?.map((contact, index) => (
            <div key={index} className="bg-muted/50 rounded-lg p-4">
              <div className="flex items-start gap-3 mb-3">
                <div className="bg-error/10 p-2 rounded-md">
                  <Icon name={contact?.icon} size={18} color="var(--color-error)" />
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-foreground text-sm mb-1">{contact?.title}</h4>
                  <p className="text-sm text-muted-foreground">{contact?.contact}</p>
                </div>
              </div>
              <div className="space-y-1.5">
                <a 
                  href={`mailto:${contact?.email}`}
                  className="flex items-center gap-2 text-sm text-primary hover:underline"
                >
                  <Icon name="Mail" size={14} color="currentColor" />
                  {contact?.email}
                </a>
                <a 
                  href={`tel:${contact?.phone}`}
                  className="flex items-center gap-2 text-sm text-primary hover:underline"
                >
                  <Icon name="Phone" size={14} color="currentColor" />
                  {contact?.phone}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Government Resources */}
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Globe" size={20} color="var(--color-primary)" />
          Government Resources
        </h3>
        <div className="space-y-2">
          {governmentResources?.map((resource, index) => (
            <a
              key={index}
              href={resource?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between p-3 rounded-md hover:bg-muted transition-smooth group"
            >
              <span className="text-sm text-foreground group-hover:text-primary transition-smooth">
                {resource?.title}
              </span>
              <Icon 
                name={resource?.icon} 
                size={16} 
                color="var(--color-muted-foreground)" 
                className="group-hover:text-primary transition-smooth"
              />
            </a>
          ))}
        </div>
      </div>

      {/* Download Offline Tutorials */}
      <div className="bg-gradient-to-br from-primary/10 to-secondary/10 border border-primary/20 rounded-lg p-6">
        <div className="flex items-start gap-3 mb-4">
          <div className="bg-primary/10 p-2 rounded-md">
            <Icon name="Download" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold text-foreground mb-1">
              Offline Tutorials
            </h3>
            <p className="text-sm text-muted-foreground">
              Download tutorials for field operations without internet access
            </p>
          </div>
        </div>
        <Button fullWidth variant="outline" iconName="Download">
          Download All Tutorials
        </Button>
      </div>
    </div>
  );
};

export default QuickAccessPanel;